import Phaser from "phaser";

export class BootScene extends Phaser.Scene {
    constructor() {
        super("BootScene");
    }

    preload(): void {
        this.load.svg("powerup-trident", "assets/powerups/powerup-trident.svg");
        this.load.svg("powerup-bow", "assets/powerups/powerup-bow.svg");
        this.load.svg("powerup-gas", "assets/powerups/powerup-gas.svg");
        this.load.svg("powerup-speed", "assets/powerups/powerup-speed.svg");
        this.load.svg("powerup-frenzy", "assets/powerups/powerup-frenzy.svg");

        this.load.svg("bluegill", "assets/fish/bluegill.svg");
        this.load.svg("crappie", "assets/fish/crappie.svg");
        this.load.svg("perch", "assets/fish/perch.svg");
        this.load.svg("largemouth-bass", "assets/fish/largemouth-bass.svg");
        this.load.svg("smallmouth-bass", "assets/fish/smallmouth-bass.svg");
        this.load.svg("walleye", "assets/fish/walleye.svg");
        this.load.svg("trout", "assets/fish/trout.svg");
        this.load.svg("northern-pike", "assets/fish/northern-pike.svg");
        this.load.svg("musky", "assets/fish/musky.svg");
    }

    create(): void {
        this.scene.start("MainMenuScene");
    }
}
